import { useNavigate } from 'react-router-dom';
import BackgroundSection from './BackgroundSection';
import Button from './Button';
import BuildBaseIcon from '../Icons/BuildBaseIcon';
import EllipseIcon from '../Icons/EllipseIcon';
import { useTheme } from '../hooks/useTheme';
import useMediaQuery from 'hooks/useMediaQuery';
import { renderWithLineBreaks } from 'utils/renderWithLineBreaks';

const Billboard = ({ data }) => {
  const { isDarkMode } = useTheme();
  const isMobileSize = useMediaQuery();
  const navigate = useNavigate();

  return (
    <BackgroundSection
      imageUrl={
        isDarkMode
          ? data.darkModeImageUrl || data.lightModeImageUrl
          : data.lightModeImageUrl
      }
      className='full-pager page-wrapper relative'
    >
      <div className='flex furniture-content'>
        {!isMobileSize && (
          <div className='furniture-content-icon'>
            <BuildBaseIcon />
          </div>
        )}
        <EllipseIcon
          size={isMobileSize ? '65%' : '25%'}
          style={{
            marginTop: isMobileSize ? 'var(--space-60)' : '0',
          }}
        />
        <div className='furniture-content-text flex flex-column row-gap-30'>
          <p className='img-page-font-grotesk font-white-color'>
            {renderWithLineBreaks(data.title)}
            <br />
            <span className='font-secondary'>
              {renderWithLineBreaks(data.titleHighlight)}
            </span>
          </p>
          <p className='paragraph-font-grotesk font-white-color'>
            {data.description}
          </p>
          {data.buttonText && data.buttonLink && (
            <Button showIcon={true} onClick={() => navigate(data.buttonLink)}>
              {data.buttonText}
            </Button>
          )}
        </div>
      </div>
    </BackgroundSection>
  );
};

export default Billboard;
